import { Badge } from "antd";

import { cn } from "@btnet/utilities-core";

import "./BTBadge.less";

interface IBTBadgeProps {
    statusType?: StatusTypes;
    overflowCount?: number;
    title?: string;
    /** Number to show in badge */
    count?: React.ReactNode;
    /** Whether to show red dot without number */
    dot?: boolean;
    className?: string;
    offset?: [number | string, number | string];
    children?: React.ReactNode;
}

export type StatusTypes = "info" | "alert" | "primary";

/**
 * BTBadge - a notification badge (a count or a dot overlaid on a child element), built on antd's
 * `Badge`. Use it to show "how many" or "is there something new" on an icon, avatar, or similar.
 *
 * This is **not** a status label. To label what state something is in (info/warning/danger/success)
 * with a standalone colored pill, use `BTStatusBadge` (from `@btnet/core-components`) instead.
 */
export function BTBadge({
    children,
    className,
    count,
    offset,
    statusType = "alert",
    overflowCount,
    title,
    dot,
}: IBTBadgeProps) {
    return (
        // eslint-disable-next-line react/forbid-elements
        <Badge
            offset={offset}
            count={count}
            className={cn("BTBadge", className, statusType)}
            overflowCount={overflowCount}
            title={title}
            dot={dot}
        >
            {children}
        </Badge>
    );
}
